import permission from './permission.fr';
import profileForm from './profile-form.fr';
import projectProfile from './project-profile.fr';
import viewer3dProfile from './viewer-3d-profile.fr';
export default {
    permission,
    profileForm,
    projectProfile,
    viewer3dProfile,
};
